import { NUMBER_REGEX } from "../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../Shared/Helper/ValidationMessage";

export const FormValidation = {
    // Regex validation for numeric input fields
    numeric: {
      pattern: NUMBER_REGEX,
      message: PATTERN_ERR_MSG,
    },
};
